// extracted by mini-css-extract-plugin
export default {"container":"Ability_container__aigXd","image":"Ability_image__+jXFI","gloss1":"Ability_gloss1__HkJuU","label":"Ability_label__xYg6j"};